import React, { useState, useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { Button } from 'antd';
import { getBlobUrl } from '../../../../helpers/getBlobUrl';
import { questionsQueryKeys } from '../../queries/questionsQueryKeys';
import styles from './DownloadAttach.module.scss';

const DownloadAttach = ({
  attachData,
  useAttachQuery,
  queryOptions,
  queryFnData,
}) => {
  const queryClient = useQueryClient();

  const [queryEnabled, setQueryEnabled] = useState(false);
  const [downloadFileLink, setDownloadFileLink] = useState(null);

  const { data: file, isFetching: isFileFetching } = useAttachQuery(
    { ...attachData, ...queryFnData },
    { enabled: queryEnabled, ...queryOptions }
  );

  const handleClick = () => {
    if (downloadFileLink) {
      downloadFileLink.click();
    } else {
      setQueryEnabled(true);
    }
  };

  useEffect(() => {
    let newLink = null;
    let cleaningFn;

    if (file && file !== 'Error') {
      const url = getBlobUrl(file);
      newLink = document.createElement('a');
      newLink.href = url;
      newLink.setAttribute('download', attachData.name);
      document.body.appendChild(newLink);
      newLink.click();

      cleaningFn = () => {
        document.body.removeChild(newLink);
        setDownloadFileLink(null);
        queryClient.removeQueries(questionsQueryKeys.attachment(attachData.id));
      };
    }

    setDownloadFileLink(newLink);

    return () => {
      if (typeof cleaningFn === 'function') {
        cleaningFn();
      }
    };
  }, [file]);

  useEffect(() => {
    if (file === 'Error' && queryEnabled) {
      setQueryEnabled(false);
    }
  }, [file, queryEnabled]);

  return (
    <Button
      type="dashed"
      icon="paper-clip"
      className={styles.root}
      onClick={handleClick}
      loading={isFileFetching}
    >
      {attachData.name}
    </Button>
  );
};

export default DownloadAttach;
